import { Component, OnInit } from '@angular/core';
import Swal from "sweetalert2";
import {Observable, Observer, Subscription} from "rxjs";
import {FormBuilder, FormGroup} from "@angular/forms";
import {Testnumber} from "../../../../models/testnumber.model";
import {OrangeService} from "../../../../services/orange.service";
import {Retailer} from "../../../../models/retailer.model";
import {environment} from "../../../../environments/environment";
import {ParamService} from "../../../../services/param.service";
import {logger} from "codelyzer/util/logger";

@Component({
  selector: 'app-orange',
  templateUrl: './orange.component.html',
  styleUrls: ['./orange.component.scss']
})
export class OrangeComponent implements OnInit {

  testNumbers: Testnumber[];
  encryptedCode: any;
  otpCode: any;
  env: any;
  orangeNumber: any;
  smsBalance: any;
  retailerBalance: {unit: string, value: number};
  retailerForm: FormGroup;
  otpForm: FormGroup;
  subscription: Subscription;


  constructor(private orangeService: OrangeService, private formBuilder: FormBuilder, private parameService: ParamService) {
    this.retailerForm = this.formBuilder.group({
      idType: 'MSISDN',
      id: '',
      encryptedPinCode: '',
      wallet: 'PRINCIPAL'
    });
    this.otpForm = this.formBuilder.group({
      id: '',
      encryptedPinCode: '',
    });
  }

  initOTPParam(): Observable<any> {
    return  new Observable((observer: Observer<any>) => {
      this.orangeService.getTestNumber().subscribe(rs => {
        // console.log(rs);
        this.testNumbers = rs;
        this.testNumbers.forEach(value => {
          if (value.type === 'RETAILER') {
            this.otpForm.controls['id'].setValue(value.msisdn);
          }
        });
      });
      this.orangeService.getEncryptedPinCode().subscribe(rs => {
        this.encryptedCode = rs.pinCode;
        this.otpForm.controls['encryptedPinCode'].setValue(rs.pinCode);
      });
      observer.complete();
    });
  }

  ngOnInit(): void {
    this.env = localStorage.getItem('env');
    if (this.env!= 'production') {
      this.orangeService.getTestNumber().subscribe(rs => {
        // console.log(rs);
        this.testNumbers = rs;
        this.testNumbers.forEach(value => {
          if (value.type === 'RETAILER') {
            this.otpForm.controls['id'].setValue(value.msisdn);
          }
        });
      });
    } else {
      this.parameService.getParam().subscribe(rs => {
        //console.log(rs);
        rs.forEach(param => {
          if (param.slug === 'orange.api.retailer.number') {
            this.orangeNumber = param.value;
          }
        })
        //console.log(this.orangeNumber)
      })
    }
    this.orangeService.getEncryptedPinCode().subscribe(rs => {
      this.encryptedCode = rs.pinCode;
      this.otpForm.controls['encryptedPinCode'].setValue(rs.pinCode);
    });
  }

  testNumber() {
    this.orangeService.getTestNumber().subscribe(rs => {
      // console.log(rs);
      this.testNumbers = rs;
    });
  }


  copyToClipboard(encryptedCode: any) {
    navigator.clipboard.writeText(encryptedCode)
      .then(() => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Code copié avec succés',
          showConfirmButton: false,
          timer: 1000
        });
      })
      .catch((error) => {
       // console.error('Error copying to clipboard: ', error);
      });
  }

  getEncryptedCode() {
    this.orangeService.getEncryptedPinCode().subscribe(rs => {
     // console.log(rs);
      this.encryptedCode = rs.pinCode;
    });
  }

  getRetailerBalance() {
    const retailer: Retailer = this.retailerForm.value;
    //console.log(retailer);

    this.orangeService.getEncryptedPinCode().subscribe(rs => {
     // console.log("pin =" + rs.pinCode)
      retailer.encryptedPinCode = rs.pinCode;
      this.orangeService.retailerBalance(retailer).subscribe(rs => {
       // console.log(rs);
        this.retailerBalance = rs;
      }, error => {
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 3500
        });
      });
    });
  }
  generateOTP() {
    this.initOTPParam().subscribe({
      complete: () => {
        // console.log(this.otpForm.value);
        // this.otpForm.controls['id'].setValue('786175707');
        //(2);
        this.otpForm.controls['id'].setValue('786175707');
        this.orangeService.generateOTPCode(this.otpForm.value).subscribe(value => {
          // console.log(value);
          this.otpCode = value.otp;
        });
      }
    });
    /*this.orangeService.generateOTPCode(this.otpForm.value).subscribe(value => {
      console.log(value);
    });*/
  }

  initRetailerBalance() {
    if (this.env!= 'production') {
      this.orangeService.getRetailer().subscribe(rs => {
         //console.log(rs);
        this.retailerForm.controls['id'].setValue(rs.msisdn);
      });
    } else {
      this.retailerForm.controls['id'].setValue(this.orangeNumber);
    }
  }

  balanceSMS() {
    this.orangeService.viewBalance().subscribe((rs: any)=> {
     // console.log(rs)
    });
  }
}
